import * as Banners from './components'

export const JBanner = {
    CMS: Banners.JCMSBanner,
    Splitted: Banners.JSplitted,
    PageHeader: Banners.JPageHeader,
    ProjectIntro: Banners.JProjectIntro,
    Advertisement: Banners.JAdvertisement,
    Section: Banners.JSectionBanner
}